import Paginator from "./Paginator-v2";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
/**
 * Componente paginador e informacion paginacion
 * @param {Object} pagerModel - Modelo de paginación con paging y handleCallApi
 * @param {string} [stickyTopValue] - Valor para el estilo 'top'
 */
const TopBarPagination = ({
    pagerModel,
    stickyTopValue,
    chosen = [],
    checkAll = false,
    showSelect = true,
}) => {
    const {t: _Tf} = useTranslation("forms");
    if (!pagerModel || !pagerModel.active) {
        return <div className="text-center">...</div>;
    }

    const {count, start, end} = pagerModel.paging;
    const topPosition = stickyTopValue ? stickyTopValue : "120px";

    return (
        <div className="row py-2 sticky-top" style={{top: topPosition}}>
            <div className="d-flex justify-content-center align-items-center">
                <div className="me-3 d-flex align-items-center">
                    Total: {count}&nbsp;&nbsp; | &nbsp;&nbsp;{start + 1} -{" "}
                    {Math.min(end, count)}
                </div>
                <Paginator
                    paging={pagerModel.paging}
                    handleCallApi={pagerModel.handleCallApi}
                />
                {showSelect && (
                    <>
                        {pagerModel.paging.size > count ? (
                            <div className="ms-3 d-flex align-items-center">
                                {chosen.length} seleccionados de {count}
                            </div>
                        ) : (
                            <div className="ms-3 d-flex align-items-center">
                                {chosen.length} seleccionados de{" "}
                                {pagerModel.paging.size}
                            </div>
                        )}

                        {checkAll && (
                            <div className="ms-3 d-flex align-items-center">
                                Seleccionar todos los {count} elementos
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default TopBarPagination;
